__turbopack_context__.v({
  "description": "styles-module-scss-module__7mVo8W__description",
  "open-orb": "styles-module-scss-module__7mVo8W__open-orb",
  "orb": "styles-module-scss-module__7mVo8W__orb",
  "retreats-icon": "styles-module-scss-module__7mVo8W__retreats-icon",
  "support-group-icon": "styles-module-scss-module__7mVo8W__support-group-icon",
  "therapy-icon": "styles-module-scss-module__7mVo8W__therapy-icon",
  "workshop-icon": "styles-module-scss-module__7mVo8W__workshop-icon",
});
